import React, { useContext, useEffect } from 'react';
import classes from './SignupPage.module.scss';
import { Container } from 'react-bootstrap';
import t from '@/utils/Language/Modal/LoginModal-translations';
import ContentPane from '@/components/ContentPane/ContentPane';
import SignupForm from './SignupForm';
import { modalContext } from '@/context/modal.context';
import useAccount from '@/hooks/useAccount';
import useSaml from '@/hooks/useSaml';
import { accountHelpers } from '@/utils/helpers';
import { SolutionContext } from '@/context/solution.context';

const SignupPage = ({ signupInvitation, ...props }) => {
  const { solution } = useContext(SolutionContext);
  const { enqueueModal } = useContext(modalContext);
  const { displayGoogleButton, openNextPage } = useAccount();
  const { samlPartner } = useSaml();

  const allowGoogleAuth = solution.includes.google_auth;
  const showGoogleAuth = allowGoogleAuth && samlPartner === false;
  const showSignupInfoPoints = solution.includes.signup_points;

  const handleSignupFlow = (data) => {
    accountHelpers.enqueueSignupModalFlow({
      enqueueModal,
      modalData: data,
      onFlowComplete: (user) => {
        if (user?.id) {
          openNextPage();
        }
      }
    });
  };

  useEffect(() => {
    if (showGoogleAuth) {
      displayGoogleButton('googleButtonContainer', handleSignupFlow);
    }
  }, [showGoogleAuth]);

  return (
    <ContentPane>
      <Container className={classes.signUpPage} {...props}>
        <div className={classes.pageHeader}>
          <span className={classes.pageTitle}>
            <h4>{t('signup_title')}</h4>
          </span>
          {showSignupInfoPoints && (
            <div className={classes.signupInfoPoints}>
              <div>{t("It's free and secure!")}</div>
              <div>{t('Safely upload and store important documents.')}</div>
              <div>{t('save_refer_resources')}</div>
            </div>
          )}
          {showGoogleAuth && <div id="googleButtonContainer" className={classes.btnGoogle}></div>}
        </div>
        <div className={classes.pageBody}>
          <SignupForm context={'page'} onSignupComplete={handleSignupFlow} signupArgs={{ signupInvitation }} />
        </div>
      </Container>
    </ContentPane>
  );
};

export default SignupPage;
